<template>
  <div>
    <Header
      :title="'一次面接候補日設定'"
      data-test="header"
    />
    <div class="boss-admin-container clearfix">
      <sidebar />
      <router-view />
    </div>
  </div>
</template>

<script>
import Header from '@/components/templates/Header'
import Sidebar from '@/components/organisms/Sidebar'

export default {
  components: {
    Sidebar,
    Header
  }
}
</script>
